/**
 * Below are the colors that are used in the app. The colors are defined in the light and dark mode.
 * There are many other ways to style your app. For example, [Nativewind](https://www.nativewind.dev/), [Tamagui](https://tamagui.dev/), [unistyles](https://reactnativeunistyles.vercel.app), etc.
 */

const tintColorLight = '#E82222';
const tintColorDark = '#E82222';
const brandColor = 'black';

export const Colors = {
  light: {
    titleText: '#000000',
    subtitleText: '#000000DE',
    text: '#00000099',
    background: '#fff',
    tint: tintColorLight,
    icon: '#687076',
    tabIconDefault: '#3C3C3C',
    tabIconSelected: tintColorLight,
    neutralButton: '#717171',
    primary: brandColor,
    buttonText: 'white',
    placeholderText: '#00000099',
    linkText: '#4B8BF1',
    progressCompleted: '#54E348',
    progressUncompleted: '#E6E6E6'
  },
  dark: {
    titleText: '#000000',
    subtitleText: '#000000DE',
    text: '#11181C',
    background: '#fff',
    tint: tintColorDark,
    icon: '#9BA1A6',
    tabIconDefault: '#9BA1A6',
    tabIconSelected: tintColorDark,
    neutralButton: '#717171',
    primary: brandColor,
    buttonText: 'white',
    placeholderText: '#00000075',
    linkText: '#4B8BF1',
    progressCompleted: '#54E348',
    progressUncompleted: '#E6E6E6'
  }
};
